// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-16072c7d] {\n  color: #999;\n  font-size: 12px;\n  display: inline-block;\n  margin: 0;\n  padding-left: 120px;\n}\n[data-v-16072c7d] .ant-form-item-with-help {\n  margin-bottom: 24px !important;\n}\n[data-v-16072c7d] .ant-form-explain {\n  position: absolute;\n}", ""]);
// Exports
module.exports = exports;
